module.exports = __webpack_public_path__ + "img/0765f0c.png";